'use client';

import { Skeleton } from '@nextui-org/react';
export const McSkeletonCard = ({
  imageHeight: _imageHeight = 250,
}: {
  imageHeight?: number;
}) => {
  return (
    <div className="relative flex w-full flex-none flex-col gap-3">
      <div className="relative shadow-black/5 shadow-none rounded-large w-full">
        <div className="relative overflow-hidden rounded-inherit w-full rounded-large">
          <div className="relative z-10 aspect-square w-full animate-pulse rounded-large bg-default-300" />
        </div>
      </div>
      <div className="mt-1 flex flex-col gap-2 px-1">
        <div className="flex items-start justify-between gap-1">
          <Skeleton className="w-4/5 rounded-lg">
            <div className="h-3 w-4/5 rounded-lg bg-default-200"></div>
          </Skeleton>
          <div className="flex items-center gap-1">
            <Skeleton className="w-2/5 rounded-lg">
              <div className="h-3 w-2/5 rounded-lg bg-default-300"></div>
            </Skeleton>
          </div>
        </div>
        {/*<p className="text-small text-default-500">*/}
        {/*  {masterclass.description}*/}
        {/*</p>*/}
        <div className="flex items-center gap-1">
          <Skeleton className="w-2/5 rounded-lg">
            <div className="h-3 w-2/5 rounded-lg bg-default-300"></div>
          </Skeleton>{' '}
          <Skeleton className="w-4/5 rounded-lg">
            <div className="h-3 w-4/5 rounded-lg bg-default-200"></div>
          </Skeleton>
        </div>{' '}
        <Skeleton className="w-2/5 rounded-lg">
          <div className="h-3 w-2/5 rounded-lg bg-default-300"></div>
        </Skeleton>
      </div>{' '}
    </div>
  );
};
